import { z } from "zod";

export const newReleaseSchema = z.object({
  description: z.string().optional(),
  locale: z.string().min(1, "Locale is required"),
  canVector: z.boolean().optional(),
});

export type NewReleaseFormValues = z.infer<typeof newReleaseSchema>;

export const importReleaseSchema = z.object({
  file: z.any().nullable(),
  active: z.boolean(),
  preserveConnections: z.boolean(),
  preserveVariables: z.boolean(),
  preserveDerivedTables: z.boolean(),
  preserveMappings: z.boolean(),
  description: z.string().optional(),
  releaseNo: z.string().optional().refine((value) => {
    const trimmed = value?.trim();
    if (!trimmed) return true;

    const parsed = Number.parseInt(trimmed, 10);
    return Number.isInteger(parsed) && parsed > 0 && String(parsed) === trimmed;
  }, "Release number must be a positive whole number"),
});

export type ImportReleaseFormValues = z.infer<typeof importReleaseSchema>;
